import { faArrowLeft } from "@jewlr/pro-light-svg-icons/faArrowLeft"
import { faCube } from "@jewlr/pro-light-svg-icons/faCube"
import { faPlusCircle } from "@jewlr/pro-light-svg-icons/faPlusCircle"
import { faPlus } from "@jewlr/sharp-light-svg-icons/faPlus"
// import { faSquare } from "@jewlr/sharp-light-svg-icons/faSquare"
import { Box, Button, Flex, FontAwesomeIcon } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useEffect, useState, Suspense } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import withImages from "areas/product/hoc/with-images"
import { toggleJ3DModal, toggleJ3DV2Modal } from "areas/product/store/actions"
import { isTestMode, retry, IS_JEWLR } from "helpers/application"
import { isTouchDevice } from "helpers/browser"
import { isVideoView, isJ3dView } from "helpers/gallery-slide-view"
import useWindowDimensions from "helpers/window-dimensions"

import FlipIcon from "./icons/flip-icon"
import Wishlist from "./icons/wishlist"
import MainImageSlider from "./main-image-slider"
// import ShippingRibbon from "./shipping-ribbon"

const ZoomImgModal = loadable(() => retry(() => import("./zoom-img-modal")), {
  ssr: false,
})

const Container = styled.div`
  flex: 1;
  position: relative;
  ${(props) => props.theme.mediaQueries.tablet`
    box-shadow: none;
    width: auto;
  `}
`
const IconsContainer = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 16px;
  position: absolute;
  width: 100%;
  z-index: 1;
  ${(props) => props.theme.mediaQueries.tablet`
    padding: 0;
    position: static;
    top: 20px;
    width: 90%;
  `}
`

const IconButton = styled(Button).attrs((props) => ({
  bg: "white",
  border: `1px solid ${props.theme.colors.grey[300]}`,
  borderRadius: "50%",
  fontSize: "16px",
  height: "34px",
  variant: "text",
  width: "34px",
  ...props,
}))``

const ViewButton = styled(Button).attrs({
  variant: "text",
})`
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grey[300]};
  border-radius: 16px;
  color: ${(props) => props.theme.colors.blackPrint};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  line-height: 22px;
  height: 32px;
  padding: 0 12px;
  ${(props) => props.theme.mediaQueries.tablet`
    background: none;
    color: ${props.theme.colors.primary};
    border: none;
    font-size: 14px;
    font-weight: 500;
    height: auto;
    letter-spacing: 0;
    line-height: 16px;
    margin: 15px 0;
    padding: 0;
    text-decoration: underline;
    text-transform: none;
  `}
`
const TangibleeContainer = styled(Box).attrs({
  id: "tangiblee-cta",
})`
  display: ${(props) => (props.show ? "flex" : "none")};
  &:empty,
  .tng-cta-wrapper:empty,
  &:has(div:last-child:empty) {
    display: none;
  }
  .tng-alt-cta:before {
    display: none;
  }
  ${(props) => props.theme.mediaQueries.mobileOnly`
    .tng-cta-wrapper {
      color: ${props.theme.colors.blackPrint};
      margin: 0;
    }
    .tng-alt-cta {
      background: ${props.theme.colors.white};
      border: 1px solid ${props.theme.colors.grey[300]};
      border-radius: 16px;
      height: 32px;
      padding: 0 12px;
    }
    .tng-cta-text {
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.02em;
      line-height: 22px;
      text-decoration: none;
      text-transform: uppercase;
    }
  `}
  ${(props) => props.theme.mediaQueries.desktop`
    .tng-alt-cta:before {
      display: block;
    }
    &:empty:only-child {
      display: block;
      height: 46px;
    }
    &:not(:empty):not(:first-child)::before {
      border-left: 1px solid #d9d9d9;
      content: "";
      height: 18px;
      margin: auto 0;
      padding-left: 18px;
    }
  `}
`
const ActionBtnRow = styled(Flex)`
  align-items: center;
  bottom: -24px;
  gap: 16px;
  justify-content: flex-start;
  margin-left: auto;
  margin-right: auto;
  padding: 0 16px;
  position: absolute;
  width: 100%;
  ${(props) => props.theme.mediaQueries.tablet`
    border-top: 1px solid ${props.theme.colors.grey[10]};
    padding-top: 5px;
    position: unset;
    width: fit-content;
  `}
`
const Exit3DWrapper = styled(Box)`
  left: 0;
  padding: 16px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`

const InternalImageAreaContent = ({
  currentSlideIndex,
  defaultImage,
  j3dSlideIndex,
  openJ3DModal,
  openJ3DV2Modal,
  productTitle,
  showFlip,
  showJ3d,
  showJ3dV2,
  slidesArray,
  styleCode,
  trackSlide,
  wizardLoading,
}) => {
  const [enableJ3D, setEnableJ3D] = useState(false)
  const [zoomImg, setZoomImg] = useState()
  const { isMobile, isTablet } = useWindowDimensions()

  const showZoomBtn =
    !isVideoView(slidesArray[currentSlideIndex]?.view) &&
    !isJ3dView(slidesArray[currentSlideIndex]?.view) &&
    !wizardLoading
  const showMobileZoomModal =
    (typeof window !== "undefined" && isTouchDevice()) || isTablet

  const doViewIn3D = () => {
    if (
      sl.config.enable_j3d_carousel &&
      (showJ3dV2 || showJ3d) &&
      j3dSlideIndex >= 0
    ) {
      trackSlide(j3dSlideIndex)
    } else if (showJ3dV2) {
      openJ3DV2Modal(true)
    } else if (showJ3d) {
      openJ3DModal(true)
    }
    if (!isTestMode) {
      dataLayer.push({
        event: "viewed-j3d",
        styleCode,
      })
    }
  }

  useEffect(() => {
    if (currentSlideIndex === j3dSlideIndex && !enableJ3D) {
      setEnableJ3D(true)
    }
  }, [currentSlideIndex])

  useEffect(() => {
    setZoomImg(null)
  }, [currentSlideIndex, showMobileZoomModal, wizardLoading, styleCode])

  useEffect(() => {
    return () => {
      trackSlide(0)
    }
  }, [])

  return (
    <Container>
      <IconsContainer>
        <Flex flexDirection="column" gap={1}>
          <Wishlist />
          {sl.config.enable_pdp_image_zoom &&
            typeof window !== "undefined" &&
            showZoomBtn &&
            isMobile && (
              <Suspense fallback={<div></div>}>
                <IconButton
                  aria-label="Zoom"
                  className="fs-ignore-rage-clicks"
                  onClick={() =>
                    setZoomImg(zoomImg ? null : slidesArray[currentSlideIndex])
                  }
                >
                  <FontAwesomeIcon
                    color="blackPrint"
                    fontSize="13px"
                    icon={faPlus}
                  />
                </IconButton>
              </Suspense>
            )}
          {/* {(showJ3d || showJ3dV2) &&
            j3dSlideIndex > 0 &&
            currentSlideIndex !== j3dSlideIndex &&
            isMobile && (
              <IconButton
                aria-label="View in 3D"
                className="fs-ignore-rage-clicks"
                onClick={() => doViewIn3D()}
              >
                <FontAwesomeIcon
                  color="blackPrint"
                  fontSize="14px"
                  icon={faSquare}
                />
              </IconButton>
            )} */}
        </Flex>
        <Flex alignItems="flex-end" flexDirection="column" gap={1}>
          {/* {IS_JEWLR() && isMobile && <ShippingRibbon />} */}
          {showFlip && <FlipIcon />}
        </Flex>
      </IconsContainer>
      <Flex
        flexDirection="column"
        minHeight={{
          _: "auto",
          desktop: "500px",
          tablet: "325px",
        }}
        position="relative"
      >
        <MainImageSlider
          defaultImage={defaultImage}
          enableJ3D={enableJ3D}
          zoomImg={zoomImg}
        />

        {/* Temporary Arrow Control for J3D */}
        {sl.config.enable_j3d_carousel &&
          j3dSlideIndex > 0 &&
          currentSlideIndex === j3dSlideIndex &&
          isTablet && (
            <Exit3DWrapper>
              <IconButton
                aria-label="Exit 3D View"
                className="fs-ignore-rage-clicks"
                onClick={() => trackSlide(currentSlideIndex - 1)}
              >
                <FontAwesomeIcon color="blackPrint" icon={faArrowLeft} />
              </IconButton>
            </Exit3DWrapper>
          )}
        {/* End of Temporary Arrow Control for J3D */}
        {typeof window !== "undefined" && !wizardLoading && (
          <Suspense fallback={<div />}>
            <ActionBtnRow>
              {(showJ3d || showJ3dV2) && !isMobile && (
                <ViewButton onClick={() => doViewIn3D()}>
                  <FontAwesomeIcon
                    color="primary"
                    display={{ _: "none", tablet: "inline-block" }}
                    fontSize="13px"
                    icon={faCube}
                    mr="6px"
                  />
                  View in 3D
                </ViewButton>
              )}
              {sl.config.enable_pdp_image_zoom &&
                typeof window !== "undefined" &&
                showZoomBtn &&
                !isMobile && (
                  <Suspense fallback={<div></div>}>
                    <>
                      {(showJ3d || showJ3dV2) && (
                        <Box bg="#d9d9d9" height="18px" width="1px" />
                      )}
                      <ViewButton
                        className="fs-ignore-rage-clicks"
                        onClick={() => {
                          setZoomImg(
                            zoomImg ? null : slidesArray[currentSlideIndex]
                          )
                        }}
                      >
                        <FontAwesomeIcon
                          color="primary"
                          fontSize="14px"
                          icon={faPlusCircle}
                          mr="6px"
                        />
                        {isTablet
                          ? "Tap to Zoom"
                          : zoomImg
                          ? "Exit Zoom"
                          : "Zoom"}
                      </ViewButton>
                    </>
                  </Suspense>
                )}
              <TangibleeContainer
                show={currentSlideIndex === 0}
              ></TangibleeContainer>
            </ActionBtnRow>
          </Suspense>
        )}
      </Flex>
      {sl.config.enable_pdp_image_zoom &&
        showMobileZoomModal &&
        typeof window !== "undefined" && (
          <Suspense fallback={<div></div>}>
            <ZoomImgModal
              onClose={() => setZoomImg(null)}
              productTitle={productTitle}
              zoomImg={zoomImg}
            />
          </Suspense>
        )}
    </Container>
  )
}

InternalImageAreaContent.propTypes = {
  currentSlideIndex: PropTypes.number,
  defaultImage: PropTypes.object,
  j3dSlideIndex: PropTypes.number,
  openJ3DModal: PropTypes.func,
  openJ3DV2Modal: PropTypes.func,
  productTitle: PropTypes.string,
  setZoomImg: PropTypes.func,
  showFlip: PropTypes.bool,
  showJ3d: PropTypes.bool,
  showJ3dV2: PropTypes.bool,
  showMobileZoomModal: PropTypes.bool,
  showZoomBtn: PropTypes.bool,
  slidesArray: PropTypes.array,
  styleCode: PropTypes.string,
  trackSlide: PropTypes.func,
  wizardLoading: PropTypes.string,
  zoomImg: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    showFlip: state.wizard.hasFaceComponentOptions,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openJ3DModal: () => {
      dispatch(toggleJ3DModal(true))
    },
    openJ3DV2Modal: () => {
      dispatch(toggleJ3DV2Modal(true))
    },
  }
}

const ImageAreaContent = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalImageAreaContent)

export default withImages(ImageAreaContent)
